const escapeRegex = (char) => char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const normalizePhoneDigits = (phone) => {
    if (phone == null || phone === '') {
        return ''
    }

    let value = String(phone).trim()
    value = value.replace(/\s+/g, '')
    value = value.replace(/[-().]/g, '')

    if (value.startsWith('+')) {
        value = value.slice(1)
    }

    return value.replace(/\D/g, '')
}

export const getPhoneComparisonKeys = (phone) => {
    const digits = normalizePhoneDigits(phone)

    if (!digits) {
        return []
    }

    const keys = new Set([digits])

    if (digits.startsWith('86') && digits.length >= 12) {
        keys.add(digits.slice(2))
    }

    if (digits.length === 11 && digits.startsWith('1')) {
        keys.add(`86${digits}`)
    }

    return [...keys]
}

export const buildPhoneMatchRegex = (phone) => {
    const digits = normalizePhoneDigits(phone)

    if (!digits) {
        return null
    }

    const body = digits.split('').map(escapeRegex).join('\\D*')

    return `^\\D*${body}\\D*$`
}

export const phonesMatch = (a, b) => {
    const keysA = getPhoneComparisonKeys(a)
    const keysB = getPhoneComparisonKeys(b)

    if (!keysA.length || !keysB.length) {
        return false
    }

    return keysA.some((key) => keysB.includes(key))
}

export const sanitizePhoneInput = (phone) => {
    if (phone == null) {
        return ''
    }

    return String(phone).trim().replace(/\s+/g, ' ')
}
